document.addEventListener('DOMContentLoaded', () => {
  const detailsElements = document.querySelectorAll('header-menu details');

  detailsElements.forEach((details) => {
    let closeTimeout;

    details.addEventListener('mouseover', () => {
      clearTimeout(closeTimeout);
      details.setAttribute('open', true);
    });

    details.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        details.removeAttribute('open');
      }, 100); // Adjust the delay as needed
    });
  });
});
